import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCompoundInterestCalculatorContext } from '../../calculator-context/compound-interest-calculator-context';
import { cn } from '../../../../../utils/tailwind';

import { scenarioIllustrations } from '../../../icons/scenario-icons';

export const CompoundInterestScenarioTabs: React.FC = () => {
    const { t } = useTranslation();
    const { activeScenario, allTabs, scenarioLabels, handleScenarioChange } = useCompoundInterestCalculatorContext();

    return (
        <div className="mx-auto hidden w-full gap-[0.6rem] rounded-full border border-[#d9cdc5] bg-[#fdf7f2] p-[0.6rem] backdrop-blur-[16px] xl:grid xl:grid-cols-4">
            {allTabs.map((tab) => {
                const isActive = activeScenario === tab.id;
                const ScenarioIcon = scenarioIllustrations[tab.id];
                return (
                    <button
                        key={tab.id}
                        type="button"
                        aria-pressed={isActive}
                        onClick={() => handleScenarioChange(tab.id)}
                        className={cn(
                            'group flex items-center justify-start gap-[1.6rem] rounded-full pl-[3.2rem] pr-[2.4rem] py-[1.2rem] text-left transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-primary',
                            isActive
                                ? 'bg-brand-secondary text-white [--scenario-icon-line:#b9b2cc] [--scenario-icon-accent:#58caff]'
                                : 'bg-transparent text-web-copy hover:bg-[#d9cdc5]/20 hover:text-brand-secondary',
                        )}
                    >
                        <span
                            aria-hidden="true"
                            className={cn(
                                'flex h-[4rem] w-[4rem] shrink-0 items-center justify-center [&_svg]:h-full [&_svg]:w-full',
                                isActive ? 'text-white' : 'text-brand-primary',
                            )}
                        >
                            <ScenarioIcon />
                        </span>
                        <span className="flex flex-col gap-[0.8rem]">
                            <span className="flex items-center gap-[0.8rem] text-[1.7rem] font-bold">
                                {scenarioLabels[tab.id]}
                            </span>
                            <span className="flex flex-wrap gap-x-[1.2rem] gap-y-[0.2rem]">
                                <span className="flex items-baseline gap-[0.4rem]">
                                    <span className="text-[1.2rem] opacity-70">
                                        {t('pages.compoundInterest.scenarios.returnLabel')}
                                    </span>
                                    <span className="text-[1.4rem] font-semibold">{tab.interestRate}%</span>
                                </span>
                                <span className="flex items-baseline gap-[0.4rem]">
                                    <span className="text-[1.2rem] opacity-70">
                                        {t('pages.compoundInterest.scenarios.inflationLabel')}
                                    </span>
                                    <span className="text-[1.4rem] font-semibold">{tab.inflationRate}%</span>
                                </span>
                            </span>
                        </span>
                    </button>
                );
            })}
        </div>
    );
};
